import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {EmployeesComponent} from './employees.component';
import {EmployeeListComponent} from './employee-list/employee-list.component';
import {EmployeeProfileComponent} from './employee-profile/employee-profile.component';
import {MyProfileComponent} from "./my-profile/my-profile.component";
import {EmployeeImportComponent} from "./employee-import/employee-import.component";

const routes: Routes = [
    {
        path: '',
        component: EmployeesComponent,
        children: [
            {
                path: 'employeelist',
                component: EmployeeListComponent,
                data: {
                    description:'Quản lý nhân sự',
                }
            },
            {
                path: 'employeeprofile',
                component: EmployeeProfileComponent,
                data: {
                    description:'Thông tin nhân sự',
                }
            },
            {
                path: 'my-profile',
                component: MyProfileComponent,
                data: {
                    description:'Thông tin cá nhân',
                }
            },
            {
                path: 'import',
                component: EmployeeImportComponent,
                data: {
                    description:'Import nhân sự',
                }
            },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class EmployeesRoutingModule {
}
